import * as React from 'react';

import { loadVariantsFromCookieOldestFirst } from '../hooks/useLastVisited/utils';

const NUMBER_OF_VISIBLE_LAST_VISITED_PRODUCTS = 12;

// Reads the `lastProducts` cookie (catalog IDs of the actually viewed variants)
// used by the product detail carousel. `excludeCatalogIds` drops every variant
// of the currently displayed product so it is not shown in its own carousel.
export const useLastVisitedVariants = (excludeCatalogIds: string[]) => {
  const excludeKey = excludeCatalogIds.join('-');

  return React.useMemo<string[]>(() => {
    const exclude = new Set(excludeKey ? excludeKey.split('-') : []);

    return loadVariantsFromCookieOldestFirst()
      .filter((catalogId) => !exclude.has(catalogId))
      .slice(-NUMBER_OF_VISIBLE_LAST_VISITED_PRODUCTS)
      .reverse();
  }, [excludeKey]);
};
